import React from "react";
import { Changes, RaceProgram, BettingInterest } from "@tvg/ts-types/Race";
import ChangesMainCard from "./MainCard";
import NextRacesChanges from "./NextRacesChanges";
import { ContentWrapper } from "./styled-components";

interface Props {
  currentRace: RaceProgram;
  races: RaceProgram[];
  changes: Changes | undefined;
}

export const nextRacesWithChanges = (
  currentRace: RaceProgram,
  races: RaceProgram[]
) =>
  races.reduce(
    (
      acc: {
        raceNumber?: string;
        changes?: Changes;
        bettingInterests?: BettingInterest[];
      }[],
      race
    ) => {
      const raceChanges = race.changes;

      if (raceChanges && race.raceNumber !== currentRace.raceNumber) {
        acc.push({
          raceNumber: race.raceNumber,
          changes: raceChanges,
          bettingInterests: race.bettingInterests
        });
      }
      return acc;
    },
    []
  );

const InfoNChangesPro = (props: Props) => {
  const { currentRace, changes, races } = props;

  return (
    <ContentWrapper>
      <ChangesMainCard changes={changes} currentRace={currentRace} />
      <NextRacesChanges
        currentRace={currentRace}
        nextRacesWithChanges={nextRacesWithChanges(currentRace, races)}
      />
    </ContentWrapper>
  );
};

export default InfoNChangesPro;
